<template>
  <PopUp :model-value="isOpen" size="sm" @update:model-value="v => !v && emit('cancel')">
    <div class="p-8 text-center">
      <div class="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round">
          <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
        </svg>
      </div>
      <h3 class="text-[1.8rem] font-bold text-[#0f1f2e] mb-2">{{ t("leaveConfirmTitle") }}</h3>
      <p class="text-[1.4rem] text-[#627282] mb-7">{{ t("leaveConfirm") }}</p>
      <div class="flex gap-3 justify-center">
        <button
          class="px-[2.4rem] py-[1rem] rounded-[10rem] border border-black/15 text-[#0f1f2e] text-[1.4rem] font-semibold hover:bg-slate-50 transition"
          @click="emit('cancel')"
        >
          {{ t("cancel") }}
        </button>
        <button
          class="px-[2.4rem] py-[1rem] rounded-[10rem] bg-red-500 text-white text-[1.4rem] font-semibold hover:opacity-85 transition disabled:opacity-40"
          :disabled="isLeavingGroup"
          @click="emit('confirm')"
        >
          {{ t("leaveConfirmBtn") }}
        </button>
      </div>
    </div>
  </PopUp>
</template>

<script setup lang="ts">
import type { Group } from "@/types/domain";
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";

defineProps<{
  isOpen: boolean;
  group: Group | null;
  isLeavingGroup?: boolean;
}>();

const emit = defineEmits<{
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);
</script>
